import { z } from "zod";

/**
 * Shared validation refinement for personal details.
 * Ensures appropriate contact method(s) are provided based on contactPreference.
 *
 * This validation is used by both the main form schema and Storybook stories
 * to ensure consistency across the application.
 *
 * @param data - The form data containing contactPreference, email and phoneNumber fields
 * @param ctx - Zod refinement context for adding validation issues
 */
export function validatePersonalDetails(
  data: { contactPreference?: string; email?: string; phoneNumber?: string },
  ctx: z.RefinementCtx,
): void {
  const contactPreference = data.contactPreference ?? "none";
  const email = (data.email ?? "").trim();
  const phoneNumber = (data.phoneNumber ?? "").trim();

  // Mode: Email & Phone ('none') - Both required
  if (contactPreference === "none") {
    if (!email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please enter your email address",
        path: ["email"],
      });
    }
    if (!phoneNumber) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please enter your phone number",
        path: ["phoneNumber"],
      });
    }
  }
  // Mode: Email only ('email') - Email is required
  else if (contactPreference === "email") {
    if (!email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please enter your email address",
        path: ["email"],
      });
    }
  }
  // Mode: Phone only ('phone') - Phone is required
  else if (contactPreference === "phone") {
    if (!phoneNumber) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please enter your phone number",
        path: ["phoneNumber"],
      });
    }
  }
}
